<template>
    <div class="ml-0">
        <section v-if="!showOneIssue">
        <p class="text-subtitle-1 my-3 font-weight-black">Contents </p>
        <p v-for="(item,index) in allIssues" :key="index"  class="body-2 py-1">
            <span class="font-weight-medium pr-2">Volume {{ item.volume }}, {{ item.year }}:</span>
            <span v-for="(number,index) in item.numbers" :key="index">
                <span v-if="index !=0">,</span>
                <router-link :to="{name:getJournalRouteNameWithIssues(), params: { journal_id: $route.params.journal_id, tab: 'all', issue : packIssue(item, number)}}"
                    class="px-1 text-decoration-underline pointer nb "> Number {{ number }}
                </router-link>
            </span>
        </p>
        </section>
        <div v-else>
            <app-one-issue :bo="bo"></app-one-issue>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import router from '../../../router';
import oneIssue from './OneIssue.vue';
export default {
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return{
            allIssues:null,
            number_to_bo_journal : {
                1 : "am.journal.bo",
                2 : "cmj.journal.bo",
                3 : "mb.journal.bo",
            }
        }
    },
    created() {
        this.getAllIssues();

        if(this.$route.params.issue) {
            const [volume, number, year] = this.$route.params.issue.split('_');
            this.setIssue({v:volume,n:number,y:year});
            this.setShowOneIssue(true);
        } else {
            this.setShowOneIssue(false);
        }
    },
    components:{
        'AppOneIssue':oneIssue,
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
            showOneIssue:'showOneIssue',
        })
    },
    methods: {
        ...mapActions('library',{
            setIssue:'setIssue',
            setShowOneIssue:'setShowOneIssue',
        }),
        async getAllIssues(){
            try{
                const res = await axios.get('/index.php/api/library/journals/volumes/'+this.$route.params.journal_id);
                if(res){
                    this.allIssues = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
        packIssue(item, number) {
            return item.volume + "_" + number + '_' + item.year;
        },
        getJournalRouteNameWithIssues() {
            if (this.bo) {
                let journal_name = this.number_to_bo_journal[parseInt(this.$route.params.journal_id)];
                if (journal_name) {
                    return journal_name;
                } else {
                    log.error("Could not translate number " + parseInt(this.$route.params.journal_id) + " into journal name");
                    // this will wrongly move the user to the non-bo page
                    return 'journal_issues'; 
                }
            } else {
                return 'journal_issues';
            }
        }
    },
}
</script>
<style scoped>
.nb{
    color:rgb(37,38,151) !important ;
}
</style>
